import useAsyncData from "../../../../hooks/use-async-data";
import CargoCompanyPassengerListParams from "./cargo-company-passenger-list-params";
import CargoCompanyPassengerList from "./cargo-company-passenger-list";
import cargoCompanyService from "../../cargo-company.service";

const useCargoCompanyPassengerList = () => {
  const { isLoading, setIsLoading, isError, setIsError, data, setData } =
    useAsyncData<CargoCompanyPassengerList>([], false);

  const load = async (
    params: CargoCompanyPassengerListParams,
    abortSignal: AbortSignal,
  ): Promise<void> => {
    setIsError(false);
    setIsLoading(true);

    try {
      const data = await cargoCompanyService.getPassengerList(
        params,
        abortSignal,
      );

      setData(data);
    } catch {
      setIsError(true);
    } finally {
      setIsLoading(false);
    }
  };

  const reset = () => {
    setIsError(false);
    setIsLoading(false);
    setData([]);
  };

  return {
    data,
    isLoading,
    isError,
    load,
    reset,
  };
};

export default useCargoCompanyPassengerList;
